import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const MessengerRedirect = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const href = window.location.href;
    const jobId = href.split("/").pop();
    const isAndroid = /Android/i.test(navigator.userAgent);

    if (isAndroid) {
      navigate(`/chat/${jobId}`, { replace: true });
    } else {
      const withoutJobId = href.substring(0, href.lastIndexOf(`/${jobId}`));
      const originalUrl = withoutJobId.replace(
        `${window.location.origin}/messenger/`,
        "https://m.me/"
      );
      window.location.replace(originalUrl);
    }
  }, [navigate]);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        backgroundColor: "#1A1E23",
      }}
    >
      <div className="loading-overlay">
        <div
          className="spinner-border"
          role="status"
          style={{ color: "var(--qualify-accent-color, #f75891)" }}
        >
          <span className="visually-hidden">Redirecting…</span>
        </div>
      </div>
    </div>
  );
};

export default MessengerRedirect;
